export default {
  en: {
    newHotel: 'New Hotel',
    hotelName: 'Hotel Name',
    hotelCode: 'Code',
    status: 'Status',
    cancel: 'Cancel',
    create: 'Create'
  },
  th: {
    newHotel: 'สร้างโรงแรม',
    hotelName: 'ชื่อ',
    hotelCode: 'โค้ด',
    status: 'สถานะ',
    cancel: 'ยกเลิก',
    create: 'สร้าง'
  }
}
